import { getMessages } from '../../../../../../store/constants';

export const BOARD_SECTION_EMAIL_NOTIFICATIONS = getMessages().getText('board_settings.notification.email');
export const BOARD_SECTION_PUSH_NOTIFICATIONS = getMessages().getText('board_settings.push_notification.title');
